var sideHeight = $('.cities').outerHeight();
function resizeAndReload() {
    $('.cities').height(sideHeight);
    slyelement.obj.reload();
}

if (window.innerWidth >= 1030) {
    var slyelement = {
        obj: {},
        el: '.cities',
        options: {
            speed: 300,
            easing: 'swing',
            activatePageOn: 'click',
            mouseDragging: 1,
            touchDragging: 1,
            scrollBy: 30,
            dragHandle: 1,
            dynamicHandle: 1,
            clickBar: 1,
            scrollBar: $('.scrollbar'),
            forward: $('.scroll-down i'),
            backward: $('.scroll-up i')
        }
    };


    $(function () {
        slyelement.obj = new Sly($(slyelement.el), slyelement.options);

        slyelement.obj.init();
    });
}
var accordionHeader = $('.country-link .country'),
    accordionContent = $('.sidebar .country-link > ul '),
    provinceContent = $('.province-content'),
    provinceLink = $('.province-link'),
    accordionIcon = $('.country-link');


$(accordionHeader).click(function (e) {
    e.preventDefault();
    if ($(this).parent().hasClass('is-active')){
        $(this).parent().find(accordionContent).slideUp('slow', function () {
            // if (window.innerWidth >= 1030) {
            //     resizeAndReload();
            // }
        });
        $(this).parent().removeClass('is-active');
    }
    else {
        // close other content
        $(accordionHeader).not(this).parent().find(accordionContent).slideUp('slow', function () {
            // if (window.innerWidth >= 1030) {
            //     resizeAndReload();
            // }
        });
        $(accordionHeader).not(this).parent().removeClass('is-active');
        $(this).parent().find(accordionContent).slideDown('slow', function () {
            // if (window.innerWidth >= 1030) {
            //     resizeAndReload();
            // }
        });
        $(this).parent().addClass('is-active');
    }
});
$(provinceLink).click(function (e) {
    if ($(this).hasClass('is-active')) {
        $(this).parent().find(provinceContent).slideUp('slow', function () {
            // if (window.innerWidth >= 1030) {
            //     resizeAndReload();
            // }
        });
        $(this).removeClass('is-active');
    } else {
        $(provinceLink).not(this).parent().find(provinceContent).slideUp('slow', function () {
            // if (window.innerWidth >= 1030) {
            //     resizeAndReload();
            // }
        });
        $(provinceLink).not(this).parent().removeClass('is-active');
        $(provinceLink).not(this).removeClass('is-active');
        $(this).parent().find(provinceContent).slideDown('slow', function () {
            // if (window.innerWidth >= 1030) {
            //     resizeAndReload();
            // }
        });
        $(this).addClass('is-active');
    }
});


// WEBPACK FOOTER //
// ./resources/assets/js/sidebar.js